import React from 'react';
import FeatureGates from '@atlaskit/feature-gate-js-client';

import { OldCoursePage } from 'src/pages/OldCoursePage';
import { NEW_COURSE_PAGE_FF } from 'src/constants';
import { CoursePage } from 'src/pages/CoursePage/CoursePage';

export const CoursePageFFWrapper = (): React.ReactElement => {
  const isNewCoursePageAvailable = FeatureGates.checkGate(NEW_COURSE_PAGE_FF);

  if (isNewCoursePageAvailable) {
    return <CoursePage />;
  }

  return <OldCoursePage />;
};
